import React, {useState, useEffect} from "react";

const Survey = (props, ref) => {
    const {surveyUrl} = props;

    useEffect(() => {
        let surveyScriptElement = document.getElementById('survey-script');
        if(surveyScriptElement) {
            surveyScriptElement.parentNode.removeChild(surveyScriptElement);
        }
        surveyScriptElement = document.createElement("script");
        surveyScriptElement.src = surveyUrl;
        surveyScriptElement.id = 'survey-script';
        document.body.appendChild(surveyScriptElement);
    },[]);

    return <div id="smcx-sdk"></div>;
}

export default Survey;